import { render } from "./CompentencyAssessment.vue?vue&type=template&id=297423a4"
import script from "./CompentencyAssessment.vue?vue&type=script&lang=ts"
export * from "./CompentencyAssessment.vue?vue&type=script&lang=ts"

import "./CompentencyAssessment.vue?vue&type=style&index=0&id=297423a4&lang=scss&scope=true"
script.render = render

export default script